module.exports = __webpack_public_path__ + "img/fTLyNFrv.c867ee7d.svg";